import React from 'react';

export default function ConfirmCiteListDeletionModalOpen({ confirmDelete, cancelDelete }) {
  return (
    <div className="new-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-dialog modal-md delete-modal">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <img className="react-header-logo" src="/logo_dark.svg" alt="" />
            </div>
          </div>
          <div className="modal-body">
            <p className="delete-text">
              This cite list is shared with other users. Are you sure you want to remove this case?
            </p>
            <div className="button-row">
              <div
                className="modal-button"
                onClick={confirmDelete}
              >
                Yes
              </div>
              <div className="modal-button modal-button-outline" onClick={cancelDelete}>
                No
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
